
































import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { User } from '@/data/models/user.model';
import UtenteCallCenter from '@/views/utenti/utente/UtenteCallCenter.vue';

@Component({
	components: {
		UtenteCallCenter,
	},
})
export default class InfoOperatore extends Vue {
	@Prop() operatore?: User;

	@Ref('callcenter') userCallcenter!: UtenteCallCenter;

	constructor() {
		super();
	}

	save() {
		this.userCallcenter.submit();
		this.$emit('save');
	}

}
